import './ProviderLogo.0e3bac0fadd2d88652224c13460ee73e.css';
export default {"logo":"_logo_1wem7_1"};